import {
  ApplicationFormForCodeType,
  ApplicationFormType,
} from 'src/app/shared/types/registration.type';

export namespace RegistrationAction {
  export class Register {
    static readonly type = '[RegistrationAction] Register';
    constructor(public body: ApplicationFormForCodeType) {}
  }

  export class RegisterConfirm {
    static readonly type = '[RegistrationAction] RegisterConfirm';
    constructor(public body: ApplicationFormType) {}
  }

  export class VerifyToken {
    static readonly type = '[RegistrationAction] VerifyToken';
    constructor(public token: string) {}
  }

  // export class CreateAccount {
  //   static readonly type = '[RegistrationAction] CreateAccount';
  //   constructor(public body: RegisterFormType) {}
  // }

  export class GetRegisterInfo {
    static readonly type = '[RegistrationAction] GetRegisterInfo';
    constructor() {}
  }
}
